import { render, staticRenderFns } from "./bottomNavStyle.vue?vue&type=template&id=171a0197&scoped=true"
import script from "./bottomNavStyle.vue?vue&type=script&lang=js"
export * from "./bottomNavStyle.vue?vue&type=script&lang=js"
import style0 from "./bottomNavStyle.vue?vue&type=style&index=0&id=171a0197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171a0197",
  null
  
)

export default component.exports